import { Offer } from "@duffel/api/types";

export const isFixtureOfferId = (offerId: Offer["id"]): boolean =>
  offerId.startsWith("fixture_off_");
;
import "/Users/jekri/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";